import { Repository } from "@react3l/react3l/core";
import { serialize } from "@react3l/react3l/helpers";
import { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
import { BASE_API_URL, PUBLIC_URL } from "config/consts";
import { FORBIDENT_ROUTE, LOGIN_ROUTE } from "config/route-consts";
import { parseJsonKeepBigInts } from "helpers/json";
import * as Cookie from "js-cookie";
import appMessageService, { messageType } from "services/app-message-service";

export const httpConfig: AxiosRequestConfig = {
  withCredentials: false,
  baseURL: BASE_API_URL,
  // ID end user là số nguyên lớn; parse mặc định làm tròn mất chữ số cuối (docs/api-backend.md mục 1.1).
  transformResponse: [parseJsonKeepBigInts],
  headers: {
    "Content-Type": "application/json",
  },
};

Repository.requestInterceptor = function(
  config: AxiosRequestConfig
): AxiosRequestConfig {
  if (typeof config.params === "object" && config.params !== null) {
    config.params = serialize(config.params);
  }
  var token = Cookie.get("Token");
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  if (config.data instanceof FormData) {
    config.headers["Content-Type"] = "multipart/form-data";
    return config;
  }

  if (typeof config.data === "object" && config.data !== null) {
    config.data = serialize(config.data);
  }

  return config;
};

Repository.responseInterceptor = function(
  response: AxiosResponse
): AxiosResponse {
  if (typeof response.data === "object" && response.data !== null) {
    if (response.headers["content-type"]?.startsWith("application/json")) {
      response.data = serialize(response.data);
    } // serialize data just apply with json
  }
  return response;
};

Repository.errorInterceptor = function(error: AxiosError): AxiosError {
  // log error if dev environment
  if (error?.response?.status) {
    switch (error.response.status) {
      case 400:
        appMessageService.messageFactory({
          type: messageType.ERROR,
          title: "Lỗi khi thực hiện thao tác này",
          description: error.response.statusText,
        });
        break;
      case 401:
        appMessageService.messageFactory({
          type: messageType.ERROR,
          title: "Bạn chưa đăng nhập để thực hiện thao tác",
          description: error.response.statusText,
        });
        Cookie.remove("Token");
        window.location.href = `${PUBLIC_URL || ""}${LOGIN_ROUTE}`;
        break;
      case 403:
        appMessageService.messageFactory({
          type: messageType.ERROR,
          title: "Bạn không có quyền thực hiện thao tác",
          description: error.response.statusText,
        });
        window.location.href = `${PUBLIC_URL || ""}${FORBIDENT_ROUTE}`;
        break;
      case 420:
        appMessageService.messageFactory({
          type: messageType.ERROR,
          title: "lỗi BE",
          description: error.response.statusText,
        });
        break;
      case 500:
        appMessageService.messageFactory({
          type: messageType.ERROR,
          title: "Lỗi hệ thống",
          description: error.response.statusText,
        });
        break;
      case 502:
        appMessageService.messageFactory({
          type: messageType.ERROR,
          title: "Server BE không hoạt động",
          description: error.response.statusText,
        });
        break;
      case 504:
        appMessageService.messageFactory({
          type: messageType.ERROR,
          title: "Phản hồi quá chậm",
          description: error.response.statusText,
        });
        break;
      default:
        break;
    }
  }
  throw error;
};
